import script from "./IconNavChecron.vue?vue&type=script&setup=true&lang=js"
export * from "./IconNavChecron.vue?vue&type=script&setup=true&lang=js"

import "./IconNavChecron.vue?vue&type=style&index=0&id=b208cbc8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b208cbc8"]])

export default __exports__